export enum ArtGroupsEnum {
  all = 0,
  text = 1,
  audio = 2,
  english = 8,
  printed = 9,
  podcast = 10,
  podcast_episode = 11,
  webtoon = 12,
}

// Возможные точки запроса артов. Нужно для расположения результатов в правильном месте
// Даст возможность избавиться от искусственных ArtGroupsEnum (recommendation и listContext) и привести группы к виду бекенда
export enum ArtTargetEnum {
  text = 1,
  audio,
  recommendation,
  listContext,
}

export enum ArtSortTypesEnum {
  popular = "popular",
  new = "new",
  series = "series",
  written_at = "written_at",
}
